import React from 'react';

export const ShapeLibraryIcon = ({
  width = 24,
  height = 24,
  color = '#000',
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11 2H2v9h9V2z" fill="#000" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 6.5a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM17.5 9a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"
      fill="#000"
    />
    <path d="M6.5 13a4.5 4.5 0 100 9 4.5 4.5 0 000-9z" fill={color} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 13v9h9v-9h-9zm2 2v5h5v-5h-5z"
      fill={color}
    />
  </svg>
);
